import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageService } from './image.service';
import { NgxCaptureModule } from 'ngx-capture';

@NgModule({
  declarations: [],
  imports: [CommonModule, NgxCaptureModule],
  providers: [ImageService],
})
export class ImageModule {}
